import { render, staticRenderFns } from "./FiltrosIcon.vue?vue&type=template&id=6f44e4f2"
import script from "./FiltrosIcon.vue?vue&type=script&lang=js"
export * from "./FiltrosIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports